import React from "react";

import { Typography } from "@mui/material";
import ModalContainerModule from "../../../modules/modalContainer";
import {
  DetailsCardContainer,
  DetailsColumn,
  DetailsContainer,
  DetailsLabel,
  DetailsRow,
  DetailsText,
} from "../../../../constants/component.constants";
import { formatShortDateTime } from "../../../../util/util";

export default function ViewTenantModal(props) {

  return (
    <ModalContainerModule
      size="small"
      cancel={props.closeModal}
      openModal={props.openModal}
      modalTitle={`${props.tenantToView.name}`}
    >
      <Typography
        id="viewOwnerModal"
        variant="h5"
        component="h5"
        sx={{ marginBottom: 0, paddingBottom: 0, color: "#037171" }}
      >
        Tenant's Details
      </Typography>
      <DetailsCardContainer
        sx={{
          boxShadow: 0,
          width: "100%",
          height: "auto",
          padding: 0,
          margin: 0,
        }}
      >
        <DetailsContainer container sx={{ marginTop: 0 }}>
          <DetailsColumn sx={{ width: { xs: "100%", lg: "50%" } }}>
            <DetailsRow>
              <DetailsLabel>Name: </DetailsLabel>
              <DetailsText>
                {props.tenantToView ? props?.tenantToView?.name : ""}
              </DetailsText>
            </DetailsRow>

            <DetailsRow>
              <DetailsLabel>Email:</DetailsLabel>
              <DetailsText>
                {props.tenantToView ? props?.tenantToView?.email : ""}
              </DetailsText>
            </DetailsRow>

            <DetailsRow>
              <DetailsLabel>Mobile Phone (Primary Number): </DetailsLabel>
              <DetailsText>
                {props.tenantToView ? props?.tenantToView?.mobilePhone : ""}
              </DetailsText>
            </DetailsRow>

            {props.tenantToView?.officePhone && (
              <DetailsRow>
                <DetailsLabel>Office Phone (Secondary Number): </DetailsLabel>
                <DetailsText>
                  {props.tenantToView ? props?.tenantToView?.officePhone : ""}
                </DetailsText>
              </DetailsRow>
            )}

            <DetailsRow>
              <DetailsLabel>Property: </DetailsLabel>
              <DetailsText>
                {props.tenantToView ? props?.tenantToView?.property : ""}
              </DetailsText>
            </DetailsRow>
          </DetailsColumn>
          <DetailsColumn sx={{ width: { xs: "100%", lg: "50%" } }}>
            {props?.tenantToView.type === "Individual" && (
              <>
                <DetailsRow>
                  <DetailsLabel>ID Type: </DetailsLabel>
                  <DetailsText>
                    {props.tenantToView ? props?.tenantToView?.idTypeCd : ""}
                  </DetailsText>
                </DetailsRow>

                <DetailsRow>
                  <DetailsLabel>ID Number: </DetailsLabel>
                  <DetailsText>
                    {props.tenantToView ? props?.tenantToView?.idNumber : ""}
                  </DetailsText>
                </DetailsRow>
              </>
            )
            }

            <DetailsRow>
              <DetailsLabel>Date Created: </DetailsLabel>
              <DetailsText>
                {props.tenantToView ? formatShortDateTime(props?.tenantToView?.dateCreated) : ""}
              </DetailsText>
            </DetailsRow>

            {props?.tenantToView?.units && (
              <DetailsRow>
                <DetailsLabel>Unit (s): </DetailsLabel>
                <DetailsText>
                  {props.tenantToView ? props?.tenantToView?.units : ""}
                </DetailsText>
              </DetailsRow>
            )}
            {props?.tenantToView?.meters && (
              <DetailsRow>
                <DetailsLabel>Meters (s): </DetailsLabel>
                <DetailsText>
                  {props.tenantToView ? props?.tenantToView?.meters : ""}
                </DetailsText>
              </DetailsRow>
            )}
          </DetailsColumn>
        </DetailsContainer>
      </DetailsCardContainer>
    </ModalContainerModule>
  );
}
